/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Col_Export_IdInputs */

const cs_import_broker_col_export_id = /** @type {(inputs: Import_Broker_Col_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export id`)
};

const en_import_broker_col_export_id = /** @type {(inputs: Import_Broker_Col_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export id`)
};

/**
* | output |
* | --- |
* | "Export id" |
*
* @param {Import_Broker_Col_Export_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_col_export_id = /** @type {((inputs?: Import_Broker_Col_Export_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Col_Export_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_col_export_id(inputs)
	return cs_import_broker_col_export_id(inputs)
});